import { useQuery } from "@tanstack/react-query";
import useMutationWithInvalidation from "neetocommons/react-utils/useMutationWithInvalidation";

import tableConfigurationApi from "./api";
import { TABLE_CONFIGURATION_QUERY_KEY } from "./constants.js";

const useFetchTableConfiguration = ({ tableKey, options = {} }) =>
  useQuery({
    queryKey: [TABLE_CONFIGURATION_QUERY_KEY, tableKey],
    enabled: !!tableKey,
    queryFn: () => tableConfigurationApi.fetch(tableKey),
    ...options,
  });

const useUpdateTableConfiguration = (tableKey, options = {}) =>
  useMutationWithInvalidation(tableConfigurationApi.update, {
    keysToInvalidate: [[TABLE_CONFIGURATION_QUERY_KEY, tableKey]],
    ...options,
  });

const useDestroyTableConfiguration = (tableKey, options = {}) =>
  useMutationWithInvalidation(tableConfigurationApi.destroy, {
    keysToInvalidate: [[TABLE_CONFIGURATION_QUERY_KEY, tableKey]],
    ...options,
  });

export {
  useFetchTableConfiguration,
  useUpdateTableConfiguration,
  useDestroyTableConfiguration,
};
